import React, { useEffect } from 'react'
import Event10 from './eventImg/event-7-june.webp'


const Event11 = () => {
    useEffect(() => {
        document.title = "ISHRAE Knowledge Talk on ALL ABOUT HVAC PUMPS";
      }, []);
  return (
    <>
   <div className='eventheading'>

<h1  className='text-center'>7 June 2025</h1> 
<h3 className='text-center'>ISHRAE Knowledge Talk on ALL ABOUT HVAC PUMPS</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event10} alt='ISHRAE Knowledge Talk on ALL ABOUT HVAC PUMPS'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/j0SpqKqvXyA=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event11

